<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="10">
        <h2 class="text-center top-title" v-html="$t('title_EmbedIntroduction')"/>
        <v-spacer class="my-3"/>
        <p class="text-center headline" v-html="$t('subtitle_EmbedIntroduction', { partnerShortName: $store.state.whitelabel.partner.shortName })"></p>
      </v-col>
    </v-row>
    <v-spacer class="my-2"/>
    <v-row justify="center">
      <v-carousel :show-arrows="false" hide-delimiters height="40vh" cycle>
        <v-carousel-item v-for="feature in (features)" v-bind:key="feature.name">
          <v-img :src="feature.img" contain max-height="35vh" position="center center"/>
          <p class="text-center mt-3">{{ $t(`features.${feature.name}`) }}</p>
        </v-carousel-item>
      </v-carousel>
    </v-row>
    <v-spacer class="my-5"/>
    <v-row justify="center">
      <v-col cols="10">
        <div class="text-center mb-7">
          <v-btn class="submit-button button-giant" @click="firstJoinSwiset">{{ $t('btnJoinSwiset') }}</v-btn>
        </div>
        <p class="text-center cta-link-swiset mb-0" v-html="$t('alreadyOnSwiset')" @click="authWithSSO"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "EmbedIntroduction",
  data() {
    return {
      features: [
        {name: 'journal', img: 'https://hub.swiset.com/wp-content/uploads/2023/03/features-WL_Journal-WL.png'},
        {name: 'mentor', img: 'https://hub.swiset.com/wp-content/uploads/2023/03/features-WL_Mentor-WL.png'},
        {name: 'plan', img: 'https://hub.swiset.com/wp-content/uploads/2023/03/features-WL_Plan-WL.png\n'},
        {name: 'fundingHunt', img: 'https://hub.swiset.com/wp-content/uploads/2023/03/features-WL_Funding-Hunt-WL.png'},
        {name: 'tournament', img: 'https://hub.swiset.com/wp-content/uploads/2023/03/feautres-WL_Tournament-WL.png'},
        {name: 'community', img: 'https://hub.swiset.com/wp-content/uploads/2023/04/comunidades_Tournament-WL-copia.png'},
      ],
    };
  },
  mounted() {
  },
  methods: {
    firstJoinSwiset() {
      this.$store.state.whitelabel.isNewUser = true
      this.$router.push('/onboard');
    },
    authWithSSO() {
      this.$router.push({ name: 'embed-sso', params: { partnerShortName: this.$store.state.whitelabel.partner.shortName, } });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/global";

.top-title {
  color: var(--v-mainBlack-base);
  font: 28px 'Avenir' !important;
  font-weight: bold !important;
}

.headline {
  color: var(--v-mainBlack-base);
  font: 17px 'Avenir' !important;
}

.cta-link-swiset {
  color: var(--v-mainBlack-base);
  font: 14px 'Avenir' !important;
  cursor: pointer;
}

.main-button {
  border: 0px solid #247851 !important;
  background-color: $calm-green !important;
  padding: 3% 7% !important;
  box-shadow: 1px 1px 8px rgba(36, 120, 81, 0.7);
}

</style>

